import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import AccessField from 'js/components/Form/AccessField'
import { Col, Row } from 'js/components/Grid'

const Settings = () => {
    const { t } = useTranslation()

    const { control, getValues } = useFormContext()
    const formValues = getValues()

    return (
        <Row $spacing={20} $gutter={30}>
            <Col mobileLandscapeUp={1 / 2}>
                <AccessField
                    {...({
                        control,
                        name: 'accessId',
                        label: t('form.visible'),
                        formValues,
                    } as any)}
                />
            </Col>
        </Row>
    )
}

export default Settings
